<script>
export default {
  name: "errorNotification",
  data: function() {
    return {
    };
  },
  methods: {
    updateStatus(e) {
      console.log(e);

      this.$store.commit("setErrorNotificationStatus", e);
    },
  },
  computed: {
    notificationStatus: function() {
      return this.$store.state.errorNotificationEnabled;
    },
    notificationMessage: function() {
      return this.$store.state.errorNotificationMessage;
    },
  },
};
</script>

<template>
  <div id="errorNotification">
    <v-snackbar
      :value="notificationStatus"
      @input="updateStatus"
      color="transparent"
      elevation="0"
      class="pa-0"
      timeout="-1"
    >
      <v-alert
        elevation="5"
        type="error"
        border="left"
        dismissible
        :value="notificationStatus"
        @input="updateStatus"
      >
        {{ this.notificationMessage }}
      </v-alert>
    </v-snackbar>
  </div>
</template>
